import { ROUTE_NAMES } from '@bakbak/common';
import { CreatePostController } from '@bakbak/controller';
import * as React from "react";
import { RouteComponentProps } from "react-router-dom";
import { CreatePostView } from "./CreatePostView";


export class CreatePostConnector extends React.PureComponent<RouteComponentProps<{}>> {
  onComplete = () => {
    this.props.history.push(ROUTE_NAMES.HOME);
  }
  onCancel = () => {
    this.props.history.push(ROUTE_NAMES.HOME);
  }

  render() {
    return (
      <CreatePostController>
        {({ submit }) =>
          <CreatePostView onComplete={this.onComplete}
            submit={submit} onCancel={this.onCancel} />
        }
      </CreatePostController>
    );
  }
}


// WEBPACK FOOTER //
// ./src/modules/post/create/CreatePostConnector.tsx